// extracted by mini-css-extract-plugin
module.exports = {"page":"pages-question-editAnswer__page--3_yzY","contents":"pages-question-editAnswer__contents--2x7Lt","card":"pages-question-editAnswer__card--1cf1P"};